import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    shop_status: 0,
    shop_data: '',
    nav_status:0,
    sunData:'',
    allFieldsExist:'',
    app_cash_register_id: '', 
    messageCount: 0
  },
  mutations: {
    // 保存收银台ID
    saveAppCashRegisterId(state, app_cash_register_id) {
      state.app_cash_register_id = app_cash_register_id;
    },
    // 店铺状态
    saveShopStatus(state, shop_status) {
      state.shop_status = shop_status;
    },
    // 店铺信息
    saveShopData(state, data) {
      state.shop_data = data;
    },
    // 设置导航坐标
    saveNavStatus(state, data){
      state.nav_status = data;
    },
    setSunData(state,data){
      state.sunData = data;
    },
    saveAllFieldsExist(state,payload){ 
      state.allFieldsExist = payload;
    },
    setMessageCount(state, count) {
      state.messageCount = count;
    }
  },
  actions: {
    updateAllFieldsExist({ commit }, payload) {
        commit('saveAllFieldsExist', payload);
    }
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js